module.exports = __webpack_public_path__ + "img/shiba888-ic-mobile-right-2.e58bc5e6.png";